// RecruitmentRoutes.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import AdminLayout from "../layout/AdminLayout";
import ManageUsers from "../user-management/pages/ManageUsers";
import AdminDashboard from "../Dashboard/Pages/AdminDashboard";
import MasterData from "../masterdata-management/pages/MasterData ";
import OrganizationsMasterPage from "../masterdata-management/pages/OrganizationsMasterPage";
import SourceMasterPage from "../masterdata-management/pages/SourceMasterPage";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route path="/dashboard" element={ <AdminDashboard />}/>
        <Route path="/manage-users" element={ <ManageUsers />}/>
        <Route path="/master-data" element={<MasterData />} />
        <Route path="/master-data/organizations" element={<OrganizationsMasterPage />} />
        <Route path="/master-data/sources" element={<SourceMasterPage />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
